// index.less 必须放置在 import 的 第一个
import './index.less';
import React from 'react';
import Root from '@src/components/root';
import RouteEnhance from '@src/components/route/route-enhance';
import routeConfigs from '@src/pages/app-router/route-configs';
import RouteSwitchEnhance from '@src/components/route/route-switch-enhance';
import { HashRouter as Router } from 'react-router-dom';
import getDefaultShareParams from '../../constants/share';
import qqwxShare from '../../components/hoc/qqwx-share';
import { isMQQ, isWeiXin } from 'detect-mobile-device';

@qqwxShare(getDefaultShareParams())
export default class AppRouter extends React.PureComponent {
  /**
   * 解决移动端 qq浏览器和微信 曲面屏手机 计算font-size有误，导致页面可以滑动
   */
  componentDidMount() {
    if (isMQQ() || isWeiXin()) {
      // 必须与 meta-flexible 的 remUpperResizeLimit(500) 保持一致上限：
      // 平板微信内这行补丁曾把 768/10=76.8px 直接盖掉封顶值 50px，导致页面铺满全屏
      document.documentElement.style.fontSize = `${Math.min(window.innerWidth, 500) / 10}px`;
    }
  }
  renderRouteEnhanceElement() {
    return Object.keys(routeConfigs)
      .sort((a, b) => {
        return (routeConfigs[a].order || 0) - (routeConfigs[b].order || 0);
      })
      .map(key => <RouteEnhance key={key} {...routeConfigs[key]} />);
  }

  render() {
    return (
      <Router>
        <Root>
          <RouteSwitchEnhance>{this.renderRouteEnhanceElement()}</RouteSwitchEnhance>
        </Root>
      </Router>
    );
  }
}
